import React from 'react';
import './Terms.css'; // Import the Terms.css file for styling

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <h1 className="terms-heading">Términos de Servicio</h1>

      <h2 className="terms-subheading">1. Introducción</h2>
      <p className="terms-text">
        Bienvenido a Tu Inquilino Ideal. Al acceder y utilizar nuestro sitio web y servicios inmobiliarios, aceptas y acuerdas estar sujeto a los términos y condiciones establecidos en estos Términos de Servicio. Si no estás de acuerdo con estos términos, no debes utilizar nuestros servicios.
      </p>

      <h2 className="terms-subheading">2. Derechos de Propiedad Intelectual</h2>
      <p className="terms-text">
        Todos los materiales, contenidos y marcas en este sitio web son propiedad de Tu Inquilino Ideal y están protegidos por derechos de autor y otras leyes de propiedad intelectual. No puedes utilizar, reproducir, modificar o distribuir ningún contenido de este sitio web sin nuestro consentimiento previo por escrito.
      </p>

      <h2 className="terms-subheading">3. Cuentas de Usuario</h2>
      <p className="terms-text">
        Para acceder a ciertas funciones de este sitio web, es posible que necesites crear una cuenta de usuario. Eres responsable de mantener la confidencialidad de tu cuenta y contraseña, así como de todas las actividades que ocurran bajo tu cuenta.
      </p>

      <h2 className="terms-subheading">4. Limitación de Responsabilidad</h2>
      <p className="terms-text">
        Tu Inquilino Ideal no será responsable de ningún daño directo, indirecto, incidental, consecuente o especial que surja del uso o la incapacidad de usar este sitio web o nuestros servicios, incluso si hemos sido informados de la posibilidad de tales daños.
      </p>

      <h2 className="terms-subheading">5. Ley Aplicable</h2>
      <p className="terms-text">
        Estos Términos de Servicio se regirán e interpretarán de acuerdo con las leyes de España, sin tener en cuenta sus principios de conflicto de leyes.
      </p>

      <h2 className="terms-subheading">6. Cambios a los Términos de Servicio</h2>
      <p className="terms-text">
        Nos reservamos el derecho de modificar o reemplazar estos Términos de Servicio en cualquier momento. Al continuar utilizando el sitio web después de cualquier cambio, aceptas estar sujeto a los términos revisados.
      </p>

      <h2 className="terms-subheading">7. Contáctanos</h2>
      <p className="terms-text">
        Si tienes alguna pregunta o preocupación sobre estos Términos de Servicio, por favor contáctanos en info@tuinquilinoideal.es.
      </p>
    </div>
  );
};

export default TermsOfService;
